import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Button, Modal, Drawer, Select, Input, Typography } from 'antd';
import { UserOutlined, FilterOutlined, SettingOutlined } from '@ant-design/icons';
import { COLORS } from '../../../constants/colors';
import { 
  FilterContainer
} from '../styled';
import FilterDrawer from './FilterDrawer';

const { Text } = Typography;

const StandardInput = styled(Input)`
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  font-size: 14px !important;
  border-radius: 8px !important;
  border: 1px solid #d9d9d9 !important;
  box-shadow: none !important;
`;

const StandardButton = styled(Button)`
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  font-size: 14px !important;
  padding: 0 15px !important;
  border-radius: 8px !important;
  border: 1px solid #d9d9d9 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
`;

const RETENTION_OPTIONS = [
  { value: 1, label: '1 hour' },
  { value: 2, label: '2 hours' },
  { value: 4, label: '4 hours' },
  { value: 8, label: '8 hours' },
  { value: 12, label: '12 hours' },
  { value: 24, label: '24 hours' },
  { value: 48, label: '48 hours' },
  { value: 72, label: '3 days' },
  { value: 168, label: '7 days' },
];

const PatientFilters = ({ 
  filters, 
  onFiltersChange, 
  selectedEvent, 
  onEventChange, 
  availableEvents, 
  loadingEvents,
  completedRetentionHours,
  onCompletedRetentionChange
}) => {
  const [mobileFilterVisible, setMobileFilterVisible] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const settingsBody = (
    <div style={{ padding: '8px 0' }}>
      <Text strong style={{ display: 'block', marginBottom: '8px' }}>
        Recent Completions Retention
      </Text>
      <Text type="secondary" style={{ display: 'block', marginBottom: '12px', fontSize: '13px' }}>
        How long completed records stay visible in the Recent Completions tab.
      </Text>
      <Select
        value={completedRetentionHours}
        onChange={onCompletedRetentionChange}
        options={RETENTION_OPTIONS}
        style={{ width: '100%' }}
        size="large"
      />
    </div>
  );

  return (
    <div className="filters-animate-in">
      <FilterContainer>
        <Row gutter={[12, 12]} align="middle">
          <Col flex="auto">
            <StandardInput
              placeholder="Search by name, email, or phone number..."
              prefix={<UserOutlined style={{ color: COLORS.textMuted, fontSize: '14px' }} />}
              value={filters.search}
              onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
              allowClear
            />
          </Col>

          <Col>
            <StandardButton
              icon={<SettingOutlined />}
              onClick={() => setSettingsVisible(true)}
              style={{ width: '40px', padding: 0 }}
            />
          </Col>
          
          <Col>
            <StandardButton
              icon={<FilterOutlined />}
              onClick={() => setMobileFilterVisible(true)}
              style={{ minWidth: '100px' }}
            >
              Filter
            </StandardButton>
          </Col>
        </Row>

        {/* Filter Drawer */}
        <FilterDrawer
          visible={mobileFilterVisible}
          onClose={() => setMobileFilterVisible(false)}
          filters={filters}
          onFiltersChange={onFiltersChange}
          selectedEvent={selectedEvent}
          onEventChange={onEventChange}
          availableEvents={availableEvents}
          loadingEvents={loadingEvents}
        />

        {/* Queue Settings Modal */}
        {isMobile ? (
          <Drawer
            title="Queue Settings"
            placement="bottom"
            height="auto"
            open={settingsVisible}
            onClose={() => setSettingsVisible(false)}
            styles={{
              content: { borderTopLeftRadius: 16, borderTopRightRadius: 16 }
            }}
          >
            {settingsBody}
          </Drawer>
        ) : (
          <Modal
            title="Queue Settings"
            open={settingsVisible}
            onCancel={() => setSettingsVisible(false)}
            footer={null}
            width={400}
          >
            {settingsBody}
          </Modal>
        )}
      </FilterContainer>
    </div>
  );
};

export default PatientFilters;
